import { orderingInitialState } from '@reducers/ordering/orderingInitialState';
import { OrderingInitialState } from '@reducers/ordering/types';

export const resetOrdering = (): OrderingInitialState => orderingInitialState;
